import { AnimatePresence, motion } from 'framer-motion';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import { Advt } from './components/Advt/Advt';
import { MessagesList } from './components/MessagesList/MessagesList';
import Slideshow from './components/Slideshow/Slideshow';

const stateSlide = 'S2';

function App() {
  const { currentState, currentMessage, showedMessages, winnerMessage, speed } =
    useBroadcast({
      stateSlide,
    });
  const { duration } = useGetParams();

  console.log(showedMessages);

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className="motionBlock"
            key={`advt-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )}
        {currentState === stateSlide && currentMessage && (
          <motion.div
            className="motionBlock"
            key={`msg-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Slideshow
              currentMessage={currentMessage}
              message={currentMessage.message}
              duration={duration}
            />
          </motion.div>
        )}

        {['S3', 'S4', 'S5', 'S6'].includes(currentState) && (
          <motion.div
            className="motionBlock"
            key="msgList"
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <MessagesList
              mode={'allMessages'}
              winId={winnerMessage?.['id']}
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
